var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataTransferenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4059 92.6878H54.633V60.9132C54.633 58.5199 52.6939 56.582 50.3055 56.582H38.4951C36.1043 56.582 34.1664 58.5199 34.1664 60.9132V92.6878H29.3923C28.2971 92.6878 27.2997 93.3251 26.8406 94.3151C26.3778 95.3149 26.5399 96.4831 27.2477 97.3234L40.0283 112.354C41.1198 113.636 42.7186 114.37 44.4003 114.37C46.0821 114.37 47.6796 113.634 48.7711 112.354L61.5505 97.3234C62.2583 96.4831 62.4216 95.3125 61.9588 94.3151C61.4997 93.3251 60.5036 92.6878 59.4059 92.6878Z",
    fill: "url(#paint0_linear_341_2368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4091 58.6004C83.3189 57.3183 81.7213 56.582 80.0396 56.582C78.3579 56.582 76.759 57.3183 75.6688 58.6004L62.887 73.627C62.1804 74.466 62.0183 75.6366 62.4798 76.6341C62.9389 77.629 63.9364 78.2638 65.0328 78.2638H69.8045V110.038C69.8045 112.435 71.7423 114.373 74.1331 114.373H85.9423C88.3331 114.373 90.271 112.435 90.271 110.038V78.2626H95.0427C96.1379 78.2626 97.1365 77.6253 97.5944 76.6328C98.0584 75.6354 97.8951 74.466 97.1885 73.6258L84.4091 58.6004Z",
    fill: "url(#paint1_linear_341_2368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7972 28.7426C97.931 28.6708 97.134 28.2266 96.6168 27.5274C91.6458 20.798 83.6617 16.6475 75.1689 16.6475C74.6269 16.6475 74.0861 16.6636 73.5453 16.697C72.8251 16.7403 72.1173 16.5262 71.5431 16.0919C66.3742 12.1852 60.1076 10.0679 53.5453 10.0679C41.7942 10.0679 31.3648 16.8826 26.5015 27.2032C26.066 28.1263 25.1935 28.7661 24.1838 28.9059C11.2274 30.7064 1.21997 41.8573 1.21997 55.3012C1.21997 69.9975 13.1764 81.9552 27.8714 81.9552H29.0334V60.9132C29.0334 55.696 33.278 51.4502 38.4951 51.4502H50.3056C55.5215 51.4502 59.7661 55.696 59.7661 60.9132V69.3738L71.7609 55.2728C73.8275 52.8424 76.8457 51.4477 80.0396 51.4477C83.231 51.4477 86.2505 52.8411 88.3158 55.2703L101.099 70.2994C103.101 72.6729 103.548 75.9992 102.252 78.7909C101.71 79.9665 100.884 80.9553 99.8874 81.7213C113.017 80.0791 123.219 68.8676 123.219 55.2987C123.22 41.3586 112.453 29.8786 98.7972 28.7426Z",
    fill: "url(#paint2_linear_341_2368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_2368",
    x1: 25.9791,
    y1: 116.374,
    x2: 71.6892,
    y2: 107.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_341_2368",
    x1: 61.6193,
    y1: 116.378,
    x2: 107.325,
    y2: 107.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_341_2368",
    x1: -0.834745,
    y1: 84.4483,
    x2: 125.98,
    y2: 17.4219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_2368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTransferenceIcon);
export default __webpack_public_path__ + "static/media/data-transference-icon.eb195b2995512b555e09ff4d9962bc73.svg";
export { ForwardRef as ReactComponent };